module.exports = __webpack_public_path__ + "static/531c5a28-5575-4f58-96d4-a80f7b702d7b-4622c9999e38ce864c1553f4b79830d5.woff2";